var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21111",
    d: "M13 18.429h7.526l-1.474 1.48.806.806 2.857-2.857L19.857 15l-.806.806 1.474 1.48H13z",
    transform: "translate(-2.714 -3.571)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21112",
    d: "M13.429 8.857V6.571a.571.571 0 0 0-.166-.406l-4-4A.571.571 0 0 0 8.857 2H3.143A1.143 1.143 0 0 0 2 3.143v13.714A1.143 1.143 0 0 0 3.143 18h9.143a1.143 1.143 0 0 0 1.143-1.143v-1.143h-1.143v1.143H3.143V3.143h4.571v3.428a1.143 1.143 0 0 0 1.143 1.143h3.429v1.143zM8.857 6.571V3.377l3.194 3.194z",
    style: {
      fill: "#203662"
    },
    transform: "translate(3 2)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportNewIcon);
export default __webpack_public_path__ + "static/media/ExportNewIcon.42ab6129572482901a515f2da194a287.svg";
export { ForwardRef as ReactComponent };